import moment, {Moment} from "moment";
import {useState} from "react";
import BookingCalendarHeader from "./BookingCalendarHeader/BookingCalendarHeader";
import BookingCalendar from "./BookingCalendar/BookingCalendar";
import BookingCalendarForDay from "./BookingCalendarForDay/BookingCalendarForDay";

export type monthAndDay = "day" | "month";

const AccountBooking = () => {
    moment.updateLocale("en", {week: {dow: 1}});
    const [today, setToday] = useState<Moment>(moment());
    const [viewCalendar, setViewCalendar] = useState<monthAndDay>("month")
    const startDay = today.clone().startOf("month").startOf("week").subtract(1, "day");
    return (
        <section>
            <BookingCalendarHeader setToday={setToday} startDay={startDay} viewCalendar={viewCalendar} setViewCalendar={setViewCalendar} today={today}/>
            { viewCalendar === "month" ? <BookingCalendar startDay={startDay}/> : <BookingCalendarForDay today={today} /> }
        </section>
    )
}

export default AccountBooking;